import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BreezeRegenerateIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BreezeRegenerate",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M30.85 7.89c-3.66 0-6.72-3.05-6.72-6.71 0-.26-.21-.46-.47-.46s-.46.21-.46.47c0 3.66-3.06 6.71-6.72 6.71a.47.47 0 1 0 0 .94c3.66 0 6.72 3.05 6.72 6.71 0 .26.21.47.46.47s.47-.21.47-.47c0-3.66 3.06-6.71 6.72-6.71.26 0 .47-.21.47-.46a.47.47 0 0 0-.47-.47ZM23.92 20.03c-.67-.14-1.34.3-1.47.98-.87 4.25-4.51 7.44-8.84 7.75-2.6.19-5.1-.65-7.07-2.35a9.66 9.66 0 0 1-3.33-6.66 9.67 9.67 0 0 1 6.86-10l-1.11 1.38c-.44.53-.35 1.32.18 1.76.24.18.51.27.79.27.36 0 .73-.15.97-.46l2.83-3.5s.13-.17.16-.23c.3-.52.17-1.19-.3-1.57l-3.55-3.05c-.52-.45-1.31-.39-1.76.14-.45.52-.39 1.31.13 1.76L9.6 7.28C4 8.83.29 14.08.71 19.93A12.17 12.17 0 0 0 4.9 28.3c2.25 1.94 5.05 2.99 7.99 2.99.3 0 .6-.02.9-.04 5.44-.39 10.01-4.39 11.11-9.74.13-.68-.3-1.34-.98-1.48"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M30.85 9.1c-2.52 0-4.57-2.05-4.57-4.56 0-.63-.51-1.15-1.14-1.15S24 3.9 24 4.54c0 2.52-2.05 4.56-4.57 4.56-.63 0-1.14.51-1.14 1.15s.51 1.15 1.14 1.15c2.52 0 4.57 2.05 4.57 4.56a1.14 1.14 0 1 0 2.28 0c0-2.52 2.05-4.56 4.57-4.56.63 0 1.14-.51 1.14-1.15s-.51-1.15-1.14-1.15"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.19 18.89c-.64-.07-1.19.4-1.25 1.03-.54 5.58-5.19 9.79-10.8 9.79-5.99 0-10.85-4.87-10.85-10.86S7.16 7.99 13.14 7.99h1.2l-3.76 3.76a1.14 1.14 0 0 0 0 1.62c.22.22.52.34.81.34s.59-.11.81-.34l5.71-5.71c.45-.45.45-1.17 0-1.62L12.2.34c-.45-.45-1.17-.45-1.62 0s-.45 1.17 0 1.62l3.76 3.76h-1.2C5.89 5.71 0 11.61 0 18.86S5.9 32 13.15 32c6.8 0 12.43-5.1 13.08-11.86.06-.63-.4-1.19-1.03-1.25Z"
      })]
    })
  }));
};
BreezeRegenerateIcon.displayName = 'BreezeRegenerateIcon';